import type { FaireProductEntity } from "../../entity_types/product";

export const matcha_10: FaireProductEntity = {
  token: "matcha-10",
  type: "product",
  name: "Noon Chocolate Delights Matcha",
  brandName: "NOON WORLD",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/7bdcb47ea70190c2ecb056717ebd034be8f83de57d7d54e9b0342dd8371041b5.png",
  priceDollars: 2.5,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/7bdcb47ea70190c2ecb056717ebd034be8f83de57d7d54e9b0342dd8371041b5.png",
  weight: 0.3,
  dimensions: {
    width: 4,
    height: 5,
    depth: 1,
  },
  description: "Matcha-flavored chocolate delights",
  categoryTokens: ["cat_food-snacks"],
  tags: ["matcha", "chocolate", "snack", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
